enum TipoConta {
    ContaCorrente = "01",
    ContaPoupanca = "02",
    ContaInvestimento = "03",
    ContaAplicacaoFinanceira = "04",
    ContaEmprestimo = "05",
    CotaCapital = "06",
    ContaRetencao = "07",
    ContaLoja = "08",
    ContaSalario = "09",
    Outros = "10",
}

export default TipoConta;
